import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyLoading, selectDiscountOrder, selectLoading } from './store/slice'
import { getDiscountOrder } from './store/thunk'

const useDiscountOrder = (disableCallApi) => {
  const dispatch = useDispatch()

  const loading = useSelector(selectLoading(keyLoading.DISCOUNT_ORDER))
  const discountOrder = useSelector(selectDiscountOrder)

  useEffect(() => {
    if (!disableCallApi) {
      dispatch(getDiscountOrder())
    }
  }, [])

  return {
    loading,
    discountOrder,
  }
}

export default useDiscountOrder
